module.exports = __webpack_public_path__ + "img/mobile-with-filters.640ab81e.jpg";